import React, { useEffect, useState } from 'react'
import posService from '../../../../Services/posService'
import './AssignPosTerminalAccount.scss'
import { handleError } from 'Helpers'
import { useForm } from 'react-hook-form'
import customerService from 'Services/customerService'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import { ToastContainer } from 'react-toastify'

interface AssignPosTerminalAccountProps {
  toggleModal: () => void
  accountId?:string
}

const AssignPosTerminalAccount: React.FC<AssignPosTerminalAccountProps> = ({ toggleModal, accountId }) => {
  type FormValues = {
    msisdn: string
    posTerminalId: string
    provider: string
    authorizationCode: string
  }

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    setError: setFieldErrorRH,
    clearErrors,
    formState,
  } = useForm<FormValues>({ mode: 'onBlur' })
  const { errors } = formState

  const [loading, setLoading] = useState(false)
  const [serverError, setServerError] = useState('')

  const { showAlert } = ShowTGAlert()

  const onSubmit = async (data: FormValues) => {
    setLoading(true)
    setServerError('')
   
      await posService.setPosTerminal(data).then(()=>{
      toggleModal()
      showAlert({
        message: 'Account added successfully',
        show: true,
        title: 'Success',
        type: 'success',
      })
      } , (err) =>{ 
      setServerError(err.response.data.error || 'An error occurred')
      handleError(err)
    
      setLoading(false)
    })
  }

  const [msisdnDetails, setMsisdnDetails] = useState<{ firstName: string; lastName: string }>()

  const watchedMsisdn = watch('msisdn')

  const verifyMsisdn = async (value?: string): Promise<void> => {
    setMsisdnDetails(undefined)
    const msisdn = value || ''
    const endpoint = `customerMsisdn=${encodeURIComponent(msisdn)}`
    if (msisdn.length >= 10 && msisdn.length <= 15) {
      try {
        const response = await customerService.searchCustomer(endpoint, 1, 'DESC')
        const dataset = response.data.data.dataset
        if (dataset && dataset.length) {
          setMsisdnDetails({ firstName: dataset[0].firstName, lastName: dataset[0].lastName })
          clearErrors('msisdn')
        } else {
          setFieldErrorRH('msisdn', { type: 'manual', message: 'Phone number does not exist' })
        }
      } catch (error: any) {
        setFieldErrorRH('msisdn', { type: 'manual', message: 'Phone number does not exist' })
      }
    } else {
      // clear any remote validation errors when length not satisfied
      clearErrors('msisdn')
    }
  }

  useEffect(() => {
    verifyMsisdn(watchedMsisdn)
  }, [watchedMsisdn])
  
  useEffect(() => {
    if (accountId) {
      setValue('msisdn', accountId)
    }
  }, [accountId])

  return (
    <form onSubmit={handleSubmit(onSubmit)} className='AssignPosTerminalAccount'>
      {serverError && <div className='alert alert-danger'>{serverError}</div>}
      <div className='mb-3'>
        <label htmlFor='msisdn' className='form-label'>
          MSISDN
        </label>
        <input
          type='text'
          className='form-control'
          id='msisdn'
          {...register('msisdn', {
            required: 'MSISDN is required',
            minLength: { value: 10, message: 'MSISDN too short' },
            maxLength: { value: 15, message: 'MSISDN too long' },
          })}
        />

        {errors.msisdn && <div className='error text-danger'>{errors.msisdn.message}</div>}
        {msisdnDetails && (
          <small className='error text-success fw-bolder'>
            {msisdnDetails.firstName} {msisdnDetails.lastName}
          </small>
        )}
      </div>
      <div className='mb-3'>
        <label htmlFor='posTerminalId' className='form-label'>
          POS Terminal ID
        </label>
        <input
          type='text'
          className='form-control'
          id='posTerminalId'
          {...register('posTerminalId', { required: 'POS Terminal ID is required' })}
        />
        {errors.posTerminalId && (
          <div className='error text-danger'>{errors.posTerminalId.message}</div>
        )}
      </div>

         <div className='mb-3'>
        <label htmlFor='authorizationCode' className='form-label'>
          Authorization Code
        </label>
        <input
          type='text'
          className='form-control'
          id='authorizationCode'
          max={6}
          {...register('authorizationCode', { required: 'Authorization Code is required' })}
        />
        {errors.authorizationCode && (
          <div className='error text-danger'>{errors.authorizationCode.message}</div>
        )}
      </div>

      <div className='mb-3'>
        <label htmlFor='provider' className='form-label'>
          Provider
        </label>
        <select
          className='form-select'
          id='provider'
          {...register('provider', { required: 'Provider is required' })}
        >
          <option value=''>Select Provider</option>
          <option value='NOMBA'>NOMBA</option>
          <option value='MONIEPOINT'>MONIEPOINT</option>
          <option value='ZEDVANCE'>ZEDVANCE</option>
        </select>
        {errors.provider && <div className='error text-danger'>{errors.provider.message}</div>}
      </div>
      <button type='submit' className='btn btn-default w-100' disabled={loading}>
        {loading ? 'Submitting...' : 'Submit'}
      </button>
      <ToastContainer/>
    </form>
  )
}

export default AssignPosTerminalAccount
